/*
 * ORNATA · Sample stock notifications
 *
 * Adds the authenticated stock-alert flow to unavailable fragrance cards in
 * the Sample Service selector. Availability remains owned by
 * OrnataSampleInventory; this file only adds alert controls.
 */
(function () {
  if (window.OrnataSampleStockNotifications) {
    window.OrnataSampleStockNotifications.scan();
    return;
  }

  var PENDING_KEY = 'ornata:sample-stock-notification:pending';
  var PENDING_MAX_AGE_MS = 30 * 60 * 1000;
  var ACTION_SELECTOR = '[data-orn-sample-notification-action]';
  var API_PATH = '/apps/voorraadmelding';
  var statusQueue = [];
  var statusRequestCache = {};
  var activeStatusChecks = 0;
  var MAX_STATUS_CHECKS = 4;

  function isLoggedIn(root) {
    return root.getAttribute('data-orn-sample-customer-logged-in') === 'true';
  }

  function createIcon(kind) {
    var icon = document.createElement('span');
    icon.className = 'oga-card__sample-notification-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = kind === 'check'
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m6.5 12.5 3.5 3.5 7.5-8"></path></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"></path><path d="M13.7 21a2 2 0 0 1-3.4 0"></path></svg>';
    return icon;
  }

  function setButtonState(button, state, label) {
    button.setAttribute('data-state', state);
    button.disabled = state === 'busy' || state === 'subscribed';
    button.setAttribute('aria-busy', state === 'busy' ? 'true' : 'false');
    button.textContent = '';
    button.appendChild(createIcon(state === 'subscribed' ? 'check' : 'bell'));
    var copy = document.createElement('span');
    copy.textContent = label;
    button.appendChild(copy);
  }

  function announce(root, message) {
    var status = root.querySelector('[data-orn-sample-notification-status]');
    if (status) status.textContent = message || '';
  }

  function markSampleSubscribed(root, sampleProductId) {
    Array.prototype.slice.call(root.querySelectorAll(ACTION_SELECTOR)).forEach(function (action) {
      if (action.getAttribute('data-sample-product-id') === sampleProductId) {
        setButtonState(action, 'subscribed', 'Ingeschreven');
      }
    });
  }

  function cleanReturnState() {
    try {
      window.localStorage.removeItem(PENDING_KEY);
    } catch (_) {}

    var url = new URL(window.location.href);
    if (url.searchParams.has('ornata_sample_notify')) {
      url.searchParams.delete('ornata_sample_notify');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
  }

  function startLogin(sampleProductId) {
    try {
      window.localStorage.setItem(PENDING_KEY, JSON.stringify({
        sampleProductId: sampleProductId,
        path: window.location.pathname,
        createdAt: Date.now()
      }));
    } catch (_) {}

    var returnUrl = new URL(window.location.href);
    returnUrl.searchParams.set('ornata_sample_notify', sampleProductId);
    var loginUrl = new URL('/customer_authentication/login', window.location.origin);
    loginUrl.searchParams.set('return_to', returnUrl.pathname + returnUrl.search + returnUrl.hash);
    window.location.assign(loginUrl.pathname + loginUrl.search);
  }

  async function request(sampleProductId, method) {
    var params = new URLSearchParams({
      target_kind: 'sample_product',
      sample_product_id: sampleProductId
    });
    var response = await fetch(API_PATH + '?' + params.toString(), {
      method: method,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    var result = await response.json().catch(function () { return null; });
    return { response: response, result: result };
  }

  async function subscribe(root, button, sampleProductId) {
    if (
      button.getAttribute('data-state') === 'busy' ||
      button.getAttribute('data-state') === 'subscribed'
    ) return;

    setButtonState(button, 'busy', 'Even controleren…');
    try {
      var outcome = await request(sampleProductId, 'POST');
      if (outcome.response.status === 401 || (outcome.result && outcome.result.status === 'login_required')) {
        startLogin(sampleProductId);
        return;
      }
      if (!outcome.response.ok || !outcome.result || outcome.result.status !== 'ok') {
        throw new Error(
          (outcome.result && outcome.result.message) ||
          'De samplemelding kon niet worden aangezet.'
        );
      }

      cleanReturnState();
      markSampleSubscribed(root, sampleProductId);
      announce(
        root,
        (outcome.result.data && outcome.result.data.message) ||
        'We mailen je zodra deze sample weer beschikbaar is.'
      );
    } catch (error) {
      setButtonState(button, 'error', 'Opnieuw');
      announce(
        root,
        error instanceof Error ? error.message : 'De samplemelding kon niet worden aangezet.'
      );
    }
  }

  async function checkStatus(root, button, sampleProductId) {
    if (!button.isConnected || !isLoggedIn(root) || button.getAttribute('data-status-checked') === 'true') return;
    button.setAttribute('data-status-checked', 'true');
    try {
      if (!statusRequestCache[sampleProductId]) {
        statusRequestCache[sampleProductId] = request(sampleProductId, 'GET');
      }
      var outcome = await statusRequestCache[sampleProductId];
      if (!outcome.response.ok || !outcome.result || outcome.result.status !== 'ok') return;
      if (outcome.result.data && outcome.result.data.subscribed === true) {
        markSampleSubscribed(root, sampleProductId);
      }
    } catch (_) {}
  }

  function drainStatusQueue() {
    while (activeStatusChecks < MAX_STATUS_CHECKS && statusQueue.length) {
      var task = statusQueue.shift();
      activeStatusChecks += 1;
      checkStatus(task.root, task.button, task.sampleProductId)
        .finally(function () {
          activeStatusChecks -= 1;
          drainStatusQueue();
        });
    }
  }

  function queueStatusCheck(root, button, sampleProductId) {
    statusQueue.push({
      root: root,
      button: button,
      sampleProductId: sampleProductId
    });
    drainStatusQueue();
  }

  function createAction(root, sampleProductId) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'oga-card__sample-notification';
    button.setAttribute('data-orn-sample-notification-action', '');
    button.setAttribute('data-sample-product-id', sampleProductId);
    button.setAttribute('aria-label', 'Melding ontvangen zodra deze sample weer beschikbaar is');
    setButtonState(button, 'ready', 'Melding');

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (isLoggedIn(root)) {
        void subscribe(root, button, sampleProductId);
      } else {
        startLogin(sampleProductId);
      }
    });
    button.addEventListener('keydown', function (event) {
      event.stopPropagation();
    });
    return button;
  }

  function eligibleSample(sample) {
    return sample &&
      sample.selectable !== true &&
      sample.storeExclusive !== true &&
      String(sample.productId || '');
  }

  function renderCard(root, card, sample) {
    var existing = card.querySelector(ACTION_SELECTOR);
    if (existing) existing.remove();
    card.classList.remove('has-sample-notification');

    if (!eligibleSample(sample)) return null;
    var sampleProductId = String(sample.productId);
    var action = createAction(root, sampleProductId);
    card.classList.add('has-sample-notification');
    card.appendChild(action);
    return action;
  }

  function pendingSampleId(root) {
    if (!isLoggedIn(root)) return '';
    try {
      var pending = JSON.parse(window.localStorage.getItem(PENDING_KEY) || 'null');
      var fresh = pending && Date.now() - Number(pending.createdAt || 0) < PENDING_MAX_AGE_MS;
      var samePage = pending && String(pending.path || '') === window.location.pathname;
      var queryId = new URL(window.location.href).searchParams.get('ornata_sample_notify') || '';
      if (fresh && samePage && queryId && String(pending.sampleProductId || '') === queryId) {
        return queryId;
      }
      if (pending && !fresh) window.localStorage.removeItem(PENDING_KEY);
    } catch (_) {
      try { window.localStorage.removeItem(PENDING_KEY); } catch (_) {}
    }
    return '';
  }

  function hydrate(root, response, force) {
    var responseMarker = String(response && response.checkedAt || '');
    if (!force && responseMarker && root.__ornSampleNotificationsMarker === responseMarker) return;
    if (responseMarker) root.__ornSampleNotificationsMarker = responseMarker;

    var byProductId = response && response.byProductId ? response.byProductId : {};
    var pendingId = pendingSampleId(root);
    var pendingHandled = false;

    Array.prototype.slice.call(
      root.querySelectorAll('[data-orn-sample-db-kind="service"], [data-orn-sample-db-kind="atelier"]')
    ).forEach(function (card) {
      var sampleProductId = String(card.getAttribute('data-orn-sample-db-card') || '');
      var sample = byProductId[sampleProductId];
      var action = renderCard(root, card, sample);
      if (!action) return;

      if (pendingId && sampleProductId === pendingId) {
        pendingHandled = true;
        void subscribe(root, action, sampleProductId);
      } else if (isLoggedIn(root)) {
        queueStatusCheck(root, action, sampleProductId);
      }
    });

    if (pendingId && !pendingHandled) {
      cleanReturnState();
    }
  }

  function bind(root) {
    if (!root || root.getAttribute('data-orn-sample-notifications-bound') === 'true') return;
    root.setAttribute('data-orn-sample-notifications-bound', 'true');

    if (!root.querySelector('[data-orn-sample-notification-status]')) {
      var status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('data-orn-sample-notification-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      root.appendChild(status);
    }

    root.addEventListener('ornata:sample-catalog-rendered', function (event) { hydrate(root, event.detail || {}, true); });

    root.addEventListener('ornata:sample-inventory-ready', function (event) {
      hydrate(root, event.detail || {});
    });

    if (window.OrnataSampleInventory) {
      window.OrnataSampleInventory.ready(root).then(function (response) {
        hydrate(root, response);
      }).catch(function () {});
    }
  }

  function scan(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(
      container.querySelectorAll('[data-orn-sample-inventory-root]')
    ).forEach(bind);
  }

  window.OrnataSampleStockNotifications = { scan: scan };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();

